export default {
  musicalGenres: 'Musikalische Genres',
  seeMore: 'Weitere Informationen',
  artists: 'Künstler',
  songs: 'Songs',
  topMusicalGenres: 'Top-Musik-Genres',
  additionalGenres: 'Zusätzliche Genres',
  topArtists: 'Top-Künstler',
  additionalArtists: 'Weitere Künstler',
  topSongs: 'Top Songs',
  additionalSongs: 'Zusätzliche Lieder',
  likes: 'Mag',
  peopleLikes: 'Menschen mögen',
  additionalLikes: 'Zusätzliche Likes',
  peoplePerJourneyStatus: 'Personen pro Reisestatus'
}
